import { gettingStarted } from './privateCloudBusinessEditionConfig';
export const pagesConfig = [...gettingStarted()];
